import React from 'react';
import ProductForm from '../components/ProductForm';

const AddProduct = ({ user, setView, productIdToEdit, onAddNew }) => {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>{productIdToEdit ? 'Edit Product Batch' : 'Add New Product Batch'}</h2>
        <button type="button" className="cancel-button" style={{padding: '0.5rem 1rem'}} onClick={() => setView('dashboard')}>
            Back to Overview
        </button>
      </div>
      <p>{productIdToEdit ? 'Update the details for this product batch. Note: This will not affect existing individual items.' : 'Enter all the details for your purchased product to calculate its landing cost and profit potential.'}</p>
      <ProductForm 
        user={user} 
        setView={setView} 
        productIdToEdit={productIdToEdit}
        onAddNew={onAddNew}
      />
    </div>
  );
};

export default AddProduct;